import { mapGetters } from 'vuex';
import router from '../router';

export default {
  data() {
    return {
      queryFilters: {},
      initialFilters: {},
      busy: true,
    };
  },
  mounted() {
    this.queryFilters = { ...this.filters, ...this.initialFilters };
    this.onPaginate(this.queryFilters.page);
  },
  computed: {
    ...mapGetters('session', ['filters']),
  },
  methods: {
    removeTableColumn(label) {
      const index = this.fields.findIndex((item) => item.label === label);
      this.fields.splice(index, 1);
    },
    refreshResults() {
      this.onPaginate(this.queryFilters.page);
    },
    onPaginate(page) {
      this.queryFilters.page = page;
      this.loadResults();
    },
    applyFilters() {
      this.queryFilters.page = 1;
      this.loadResults();
    },
    onSortingChanged(ctx) {
      this.queryFilters.sort = ctx.sortBy;
      this.queryFilters.dir = ctx.sortDesc ? 'DESC' : 'ASC';
      this.loadResults();
    },
    onRowClicked(record) {
      router.push({
        name: this.rowRouteName,
        params: {
          id: record.id,
        },
      });
    },
    onCreate() {
      router.push({
        name: this.createRouteName,
      });
    },
    setRequestData() {
      this.busy = true;
      // Update applied filter state
      delete this.queryFilters.paginationFrom;
      delete this.queryFilters.paginationTo;
      this.queryFilters.rows = null;
      this.$store.commit('session/updateFilters', { ...this.queryFilters });
    },
    setResponseData(data) {
      this.queryFilters.rows = data.total;
      this.queryFilters.paginationFrom = data.from;
      this.queryFilters.paginationTo = data.to;
      this.data = data.data;
      this.busy = false;
    },
    onFilterChange() {
      this.loadResults();
    },
  },
};
